import React, { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import { TextField as TextFieldMUI, type TextFieldProps as TextFieldPropsMUI } from '@mui/material';

export type TextFieldProps = {
    onEnter?: () => void
} & TextFieldPropsMUI

const TextFieldStyled = styled(TextFieldMUI)`
    .MuiOutlinedInput-root {
        background: #f9f9fb;
    }
    .MuiSvgIcon-root {
        color: #727273;
    }
    .Mui-focused {
        .MuiSvgIcon-root {
            color: ${props => props.theme.palette.primary.main}
        }
    }
`;

/**
 * we do nothing with ref as we use inputRef for material ui
 * @param param0
 * @param ref
 * @returns
 */
const TextField = ({ onEnter, ...props }: TextFieldProps, _ref): JSX.Element => {
    const onKeyDown = ev => {
        if (ev.keyCode === 13 && onEnter) onEnter();
    };

    return <TextFieldStyled
        onKeyDown={onKeyDown}
        {...props}
    >
        {props.children}
    </TextFieldStyled>;
};

export default forwardRef(TextField);
